import { clsx } from "clsx";
import type { ReactNode } from "react";
import { Card } from "./Card";

type StatusCardTone = "info" | "error" | "empty";

export type StatusCardProps = {
  title: ReactNode;
  body?: ReactNode;
  actions?: ReactNode;
  tone?: StatusCardTone;
  className?: string;
};

export function StatusCard({
  title,
  body,
  actions,
  tone = "info",
  className,
}: StatusCardProps) {
  return (
    <Card
      className={clsx(
        "p-6 bg-surface",
        tone === "error" &&
          "border-danger-border",
        className,
      )}
    >
      <div
        className={clsx(
          tone === "info" ? "text-sm text-text-muted" : "text-base font-semibold text-text",
        )}
      >
        {title}
      </div>
      {body && <div className="mt-2 text-sm text-text-muted">{body}</div>}
      {actions && <div className="mt-6 flex flex-wrap gap-3">{actions}</div>}
    </Card>
  );
}
